import {ReactElement, useEffect} from "react";
import {Controller} from "react-hook-form";

import {HookFormContext, HookFormContextType} from "@/context/HookFormContext";
import {useGetContext} from "@/hooks/useGetContext/useGetContext";
import {AdherentBase} from "@/ts/adherent";
import {OptionNameValue} from "@/ts/formulaire";

import SelectCustom from "../Formulaire/SelectCustom/SelectCustom";

export function AdherentSelecteur({
  name,
  adherents,
  handleSelect,
  handleTrash,
}: {
  name: string;
  adherents: AdherentBase[];
  handleSelect: (value?: any, libelle?: any, complementData?: any) => void;
  handleTrash: () => void;
}): ReactElement {
  const {control, watch} = useGetContext<HookFormContextType>(
    HookFormContext,
    "HookFormContext"
  );
  const selectedAdherent = watch(name);
  const adherentOption: OptionNameValue[] = adherents?.map(adherent => {
    return {
      libelle: `${adherent.contremarque} - ${adherent.nom}`,
      value: adherent.contrat_id,
    };
  });
  useEffect(() => {
    if (selectedAdherent) {
      handleSelect(
        selectedAdherent.value,
        selectedAdherent.libelle,
        selectedAdherent.complementData
      );
    }
  }, [selectedAdherent]);
  return (
    <Controller
      name={name}
      control={control}
      render={({field}) => (
        <SelectCustom
          label="Contrat avec l'adhérent"
          testId="adherent-selecteur"
          canSearch={true}
          defaultValue=""
          name={field.name}
          watch={watch}
          disabled={adherents?.length <= 0}
          title={
            adherents?.length <= 0
              ? "Aucun adhérent n'a encore adhéré à ce programme"
              : ""
          }
          placeholder="Chercher un adhérent"
          options={adherentOption || []}
          ref={field.ref}
          handleSelect={(value, libelle) => {
            // Déclenche le changement du champ via field.onChange
            field.onChange({
              libelle: libelle,
              value,
            });
          }}
          onTrash={() => {
            field.onChange(undefined);
            handleTrash();
          }}
        />
      )}
    />
  );
}
